import type { ReactNode } from "react";

export type typeSeasonDividerProps = {
  label: string;
};

/** Visually distinct from `DayDivider`: a season boundary reads as a bigger
 * moment than a day boundary, using only existing tokens. */
export const SeasonDivider = (props: typeSeasonDividerProps): ReactNode => {
  return (
    <div className="flex items-center gap-2 py-2" data-testid="season-divider">
      <span className="h-px flex-1 bg-primary-solid" />
      <span className="text-body-strong text-ink">{props.label}</span>
      <span className="h-px flex-1 bg-primary-solid" />
    </div>
  );
};
